import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_download_icon = _resolveComponent("download-icon");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_c_s_v_icon = _resolveComponent("c-s-v-icon");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_sheet_icon = _resolveComponent("sheet-icon");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  return _openBlock(), _createBlock(_component_app_dropdown, {
    class: "view-export-dropdown",
    "no-caret": false
  }, {
    "button-content": _withCtx(() => [_createVNode(_component_wrap_with_popover, {
      width: "fit-content",
      placement: $props.placement ?? 'left'
    }, {
      title: _withCtx(() => [_createTextVNode("Download")]),
      default: _withCtx(() => [_createVNode(_component_download_icon, {
        width: 16,
        height: 16
      })]),
      _: 1
    }, 8, ["placement"])]),
    body: _withCtx(() => [_createVNode(_component_b_dropdown_item, {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('csv-download'))
    }, {
      default: _withCtx(() => [_createVNode(_component_flex_row, {
        styles: {
          justifyContent: 'space-between'
        },
        gap: 4
      }, {
        default: _withCtx(() => [_createTextVNode(" Raw CSV "), _createVNode(_component_c_s_v_icon)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_b_dropdown_item, {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('google-sheet-download'))
    }, {
      default: _withCtx(() => [_createVNode(_component_flex_row, {
        styles: {
          justifyContent: 'space-between'
        },
        gap: 4
      }, {
        default: _withCtx(() => [_createTextVNode(" Google Sheet "), _createVNode(_component_sheet_icon)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_b_dropdown_item, {
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('csv-copy'))
    }, {
      default: _withCtx(() => [_createVNode(_component_flex_row, {
        styles: {
          justifyContent: 'space-between'
        },
        gap: 4,
        id: "copy-csv"
      }, {
        default: _withCtx(() => [_createTextVNode(" Copy Data "), _createVNode(_component_app_icon, {
          icon: "copy-v2",
          color: "#000000"
        })]),
        _: 1
      }), _createVNode(_component_app_popover, {
        target: "copy-csv",
        placement: "left"
      }, {
        default: _withCtx(() => [_createTextVNode("Copy table data as CSV")]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}